import '../pages.css';
import { Link } from 'react-router-dom';

const ValplastFlexiblePartial = () => {
    return (
        <div className="page product-detail">
            <section className="product-detail-hero">
                <div className="product-detail-hero-content">
                    <Link to="/products/removable" className="back-link">← Back to Removable Prosthetics</Link>
                    <h1>Valplast® Flexible Partial</h1>
                    <p className="product-tagline">Metal-free solution with exceptional flexibility</p>
                </div>
            </section>

            <section className="product-detail-content">
                <div className="content-container">
                    <div className="product-section">
                        <h2>Description</h2>
                        <p>
                            Valplast® flexible partial dentures from <strong>AbELab</strong> are fabricated entirely from Valplast®, a biocompatible
                            nylon thermoplastic resin. This material offers exceptional flexibility and design freedom, allowing the denture to blend
                            naturally with surrounding tissues. Valplast® flexible partials provide excellent retention, comfort, strength, and
                            esthetics, making them an ideal choice for patients seeking a metal-free removable solution.
                        </p>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ValplastFlexiblePartial;
